import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchRuntimeConfig } from '../config/runtimeConfig';

const ConfigContext = createContext(null);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRuntimeConfig()
      .then((runtimeConfig) => {
        setConfig(runtimeConfig);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div>Loading configuration...</div>;
  }

  if (error) {
    return <div>Configuration error: {error.message}</div>;
  }

  // Transform config to match expected structure
  const transformedConfig = {
    ...config,
    apiConfig: {
      baseURL: config?.api?.baseUrl || '/api/v1',
      token: null, // Token will be handled by the API service layer
      ...config?.api
    }
  };

  return (
    <ConfigContext.Provider value={transformedConfig}>
      {children}
    </ConfigContext.Provider>
  );
};